import { render, staticRenderFns } from "./monthly-enclosure-add-or-update.vue?vue&type=template&id=195661ce&scoped=true&"
import script from "./monthly-enclosure-add-or-update.vue?vue&type=script&lang=js&"
export * from "./monthly-enclosure-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./monthly-enclosure-add-or-update.vue?vue&type=style&index=0&id=195661ce&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195661ce",
  null
  
)

export default component.exports